import React, { useRef } from "react";
import "../styles/Contact.css";
import Footer from "./Footer";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SuccessNotify = () => {
  toast.success("Message Sent", {
    position: "bottom-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    draggable: true,
    progress: undefined,
  });
};
const failNotify = () => {
  toast.error("Message Sending Failed! Try again", {
    position: "bottom-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

function Contact() {
  const form = useRef();
  function handleEmail(e) {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_46infrs",
        "template_4mrwqm2",
        form.current,
        "ZHGpuFbBpZV-5VFed"
      )
      .then(
        () => {
          SuccessNotify();
        },
        (error) => {
          failNotify();
        }
      );
    e.target.reset();
  }
  return (
    <section id="contact" className="contact">
      <div className="contactHeader">
        <h1>Contact</h1>
        <p>Feel free to reach out to me for any queries or opportunities.</p>
      </div>
      <div className="contactContent">
        <h1>Email Me</h1>
        <form ref={form} onSubmit={handleEmail}>
          <input
            className="contactInput"
            type="text"
            name="mail"
            id="mail"
            placeholder="Your Email"
          />
          <input
            className="contactInput"
            type="text"
            name="name"
            id="name"
            placeholder="Your Name"
          />
          <input
            className="contactInput"
            type="text"
            name="subject"
            id="subject"
            placeholder="Subject"
          />
          <textarea
            className="contactInput contactInputText"
            name="message"
            id="message"
            rows={4}
            placeholder="Message"
          />
          <button type="submit" className="contactSend">
            Send
          </button>
        </form>
        <Footer />
      </div>
    </section>
  );
}

export default Contact;
